import React from "react";
import { EmptyState } from "components/shared/EmptyState";
import { zeroData } from "utils/emptyCopy";

interface UsersEmptyStateProps {
  isLoading: boolean;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
}

const UsersEmptyState: React.FC<UsersEmptyStateProps> = ({
  isLoading,
  message = `${zeroData("users")} Try adjusting your search criteria or add a new user.`,
  actionLabel,
  onAction,
}) => {
  if (isLoading) return null;

  return (
    <EmptyState
      message={message}
      actionLabel={actionLabel}
      onAction={onAction}
    />
  );
};

export default UsersEmptyState;
